import utils from '@/mixins/utils'
const { syncTimeout } = utils.methods
const RETRIES = 30
const state = {
	archiveFile: null,
	loading: false,
	retries: RETRIES
}

const mutations = {
	SET_IMPORT_FILE (state, data) {
		state.archiveFile = data
	},
	DECREMENT_RETRIES (state) {
		state.retries--
	},
	RESET_RETRIES (state) {
		state.retries = RETRIES
	},
	SET_LOADING (state, bul) {
		state.loading = bul
	}
}

const importedSuccesfully = ({ commit, dispatch }) => {
	commit('Toast/_add', 'Archive imported successfully', { root: true })
	commit('SET_LOADING', false)
	dispatch('closeModal', null, { root: true })
	commit('RESET_RETRIES')
	dispatch('Pages/fetchAll', null, { root: true })
	dispatch('Snippets/fetchSnippets', null, { root: true })
}

const actions = {
	setFile ({ commit }, data) {
		commit('SET_IMPORT_FILE', data)
	},
	async import ({ commit, dispatch, getters, state }, options) {
		const { isCleanImport, doBackup, deleteExportId } = options
		const url = this._vm.CMS_BASE_URL + '/cms/import'
		const data = {
			ImportFile: getters.file
		}
		if (!data.ImportFile) {
			return commit('Toast/_addError', 'No import file found', { root: true })
		}
		dispatch('setAppLoader', true, { root: true })
		if (isCleanImport) {
			data.DeleteFirst = 'true'
		}
		commit('SET_LOADING', true)

		if (doBackup) {
			const moment = this._vm.$moment
			if (deleteExportId) {
				await dispatch('Export/delete', { id: deleteExportId, silent: true }, { root: true })
			}
			await dispatch('Export/export', {
				Name: `bkp${moment().format('YYYY')}${moment().format('MM')}${moment().format('DD')}${moment().format('HH')}${moment().format('mm')}${moment().format('ss')}`,
				WithTranslate: 0,
				WithUploads: 1
			}, { root: true })
		}

		await dispatch('uploadApi', {
			ingoreBaseUrl: true,
			internal: true,
			url,
			data
		}, { root: true }).then(resp => {
			resp.onload = async (e) => {
				// delete multipart header
				delete this._vm.$http.defaults.headers['Content-Type']
				const res = JSON.parse(e.target.responseText)
				if (res.Status !== '1' && state.retries >= 0) {
					commit('DECREMENT_RETRIES')
					await syncTimeout(500)
					await dispatch('checkImportStatus', res.Id)
					dispatch('setAppLoader', false, { root: true })
				} else {
					importedSuccesfully({ commit, dispatch })
				}
			}
			resp.onerror = (error) => {
				console.log(error)
				commit('SET_LOADING', false)
				commit('Toast/_addError', 'Import process failed', { root: true })
				dispatch('setAppLoader', false, { root: true })
				throw error
			}
		}).catch((err) => {
			console.error(err)
			commit('SET_LOADING', false)
			dispatch('setAppLoader', false, { root: true })
			commit('Toast/_addError', 'Upload failed', { root: true })
		})
	},
	async checkImportStatus ({ dispatch, state, commit }, id) {
		await dispatch('callApi', {
			method: 'GET',
			ingoreBaseUrl: true,
			url: this._vm.CMS_BASE_URL + '/cms/import?filter[0][name]=Id&filter[0][term]=' + id
		}, { root: true }).then(async resp => {
			if (resp.Status && resp.Status === 403) {
				commit('SET_LOADING', false)
				commit('RESET_RETRIES')
				return commit('Toast/_addError', 'Action forbidden', { root: true })
			}
			if (resp.data._embedded.import[0].Status !== '1' && state.retries >= 0) {
				// check ErrorMessage / Status 2
				if (resp.data._embedded.import[0].Status === '2') {
					commit('SET_LOADING', false)
					commit('RESET_RETRIES')
					return commit('Toast/_addError', resp.data._embedded.import[0].ErrorMessage, { root: true })
				}
				commit('DECREMENT_RETRIES')
				await syncTimeout(500)
				await dispatch('checkImportStatus', id)
			} else {
				importedSuccesfully({ commit, dispatch })
			}
		}).catch((err) => {
			console.error(err)
			let msg = ''
			if (typeof err === 'object' && err.response && err.response.data && err.response.data.Message) {
				msg = err.response.data.Message
			}
			if (!msg) msg = 'Import failed'
			commit('Toast/_addError', msg, { root: true })
		})
	}
}

const getters = {
	file: state => state.archiveFile,
	loading: state => state.loading
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
